export default {
  SET_INQUIRIES: (state, data) => {
    state.inquiries = data;
  },
};
